import React, { useState } from "react";
import {
  HeaderLeftContent,
  HeaderRightContent,
  StyledHeader,
} from "../../Common/styles/header";
import { Box, Button, Divider, Drawer, Typography } from "@mui/material";
import { Add } from "@mui/icons-material";
import AddGroupDrawer from "./Drawers/AddGroupDrawer";

type Props = {
  canCreate: boolean;
  refreshPage: () => void;
};

const GroupsHeader = ({ canCreate, refreshPage }: Props) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <>
      <StyledHeader>
        <Box sx={HeaderLeftContent}>
          <Typography variant="h2" color="text.primary">
            User Groups
          </Typography>
        </Box>
        {canCreate && (
          <Box sx={HeaderRightContent}>
            <Button
              variant="contained"
              startIcon={<Add />}
              onClick={() => setShowModal(true)}
            >
              Add User Group
            </Button>
          </Box>
        )}
      </StyledHeader>
      <Divider />
      <Drawer open={showModal} onClose={closeModal} anchor="right">
        <AddGroupDrawer closeDrawer={closeModal} refreshPage={refreshPage} />
      </Drawer>
    </>
  );
};

export default GroupsHeader;
